import {
  IEntityCreate,
  IEntityCreateFailure,
  IEntityCreateSuccess,
  IEntityDelete,
  IEntityDeleteSuccess,
  IEntityFetch,
} from "../actions";

export enum EmailDomainStatus {
  New = "new",
  PendingVerification = "pendingVerification",
  Active = "active",
  PendingDeletion = "pendingDeletion",
  PendingConfiguration = "pendingConfiguration",
  SetupFailed = "setupFailed",
}

interface IEmailDomainFlags {
  inboxUsed: boolean;
}

interface IDNSDetails {
  [key: string]: IDNSRecord[];
}

interface IDNSRecord {
  host: string;
  value: string;
}

export interface IEmailDomain extends IEntityCreateFailure {
  id: string;
  name: string;
  domain: string;
  status: EmailDomainStatus;
  flags: IEmailDomainFlags;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  dns?: IDNSDetails;
}

export interface IEmailDomainUnverified {
  errors?: { message: string }[];
  controlPanelURL: string | null;
  dcSyncURL: string | null;
  helpcenterURL: string | null;
  nameServersAvailable: boolean;
  popupHeight: string | null;
  popupWidth: string | null;
  providerName: string | null;
  websiteURL: string | null;
  id: string | null;
}

export type IFetchEmailDomainPayload = IEntityFetch;
export type ICreateEmailDomainPayload = IEntityCreate<IEmailDomain> & {
  skipRetry?: boolean;
};
export type ICreateEmailDomainSuccessPayload = IEntityCreateSuccess;
export type ICreateEmailDomainFailurePayload = IEntityCreateFailure;

export type IDeleteEmailDomainPayload = IEntityDelete;
export type IVerifyEmailDomainPayload = IEntityFetch & {
  skipRetry?: boolean;
};
export type IVerifySuccessDomainPayload = IEntityFetch;
export interface IVerifyFailureDomainPayload extends IEntityCreateFailure {
  id: string;
}
export type ISyncDeleteEmailDomainPayload = IEntityDeleteSuccess;
